import React from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import * as dateFns from "date-fns";

const DateSelector = ({ store }) => {
  const { $respondent } = store;
  return (
    <div className="flex">
      <div className="mr-2">
        <M.TextField
          id="filterDateStart"
          label="Periode Start"
          type="date"
          placeholder=""
          defaultValue={dateFns.format($respondent.filterDateStart, "yyyy-MM-dd")}
          onChange={e => $respondent.change("filterDateStart", new Date(e.target.value))}
        />
      </div>
      <div className="mr-2">
        <M.TextField
          id="filterDateEnd"
          label="Periode Einde"
          type="date"
          defaultValue={dateFns.format(new Date(), "yyyy-MM-dd")}
          onChange={e => $respondent.change("filterDateEnd", new Date(e.target.value))}
        />
      </div>
    </div>
  );
};

export default inject("store")(observer(DateSelector));
